import { Alert, AlertTitle, Link } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import { useGetAdmissionRequestDetailQuery } from '@/api/member-management/admissionRequest';

/** DMS-REQ-WEB-CHA-005 §2.1: new family member form started from an existing member. */
export default function PendingMemberLinkAlert({ userId }: { userId: string }) {
	const { t } = useTranslation();
	const { data } = useGetAdmissionRequestDetailQuery(userId);
	const member = data?.data;
	if (!member) return null;
	return (
		<Alert severity='info' sx={{ marginTop: 2, bgcolor: '#D3E9F8' }}>
			<AlertTitle>{t('identityLink.pendingMemberLinkTitle')}</AlertTitle>
			<Trans
				i18nKey='identityLink.pendingMemberLink'
				values={{
					fileNo: member.fileNo,
					name: [member.nameEn, member.nameZh].filter(Boolean).join(' '),
				}}
				components={{
					anchor: (
						<Link
							href={`/member-management/member-list/detail/${userId}`}
							target='_blank'
							rel='noopener noreferrer'
							color='#1BBED7'
						/>
					),
				}}
			/>
		</Alert>
	);
}
